import React from "react";
import { formatCurrency } from "../../helpers/utils";
import CheckBoxCustom from "../checkbox";

const TableBodyMobile = ({
  tableSettings = {},
  tableHeadings = {},
  table_data = [],
  selectable = false,
  selectedCards = [],
  handleRowClick
}) => {

  const isSelected = (cardNumber) => selectedCards.indexOf(cardNumber) !== -1;

  const getFields = () => {
    return Object.entries(tableSettings)
      .map(([key, value]) => ({id: key, value: value,}))
      .filter((h) => h.id !== "cardNumber" && h.value);
  };

  const getCell = (c, fieldId) => {
    return (
      <div className="col-6">
        <div className="text-grey font-size-12">{tableHeadings[fieldId]}</div>
        <div className="form-item-label-height font-size-12">
          {fieldId === "balance"
            ? formatCurrency(c[fieldId])
            : fieldId === "status"
            ? c[fieldId] === "active" ? "Идэвхтэй"
              : c[fieldId] === "inactive" ? "Идэвхгүй" : ""
            : c[fieldId]}
        </div>
      </div>
    );
  };

  return (
    <div className="mobile-container">
      {table_data.map((c) => {
        var isRowSelected = isSelected(c.cardNumber)
        return (
          <div 
            key={c.cardNumber} 
            className={`mobile-row ${isRowSelected ? 'selected' : ''}`}>
            {selectable && (
              <div className="ms-2">
                <CheckBoxCustom 
                  value={isRowSelected} 
                  handleChange={(e) => handleRowClick(e, c.cardNumber)}/>
              </div>
            )}
            <div className="flex-grow-1 mobile-cell">
              <div className="font-size-16 font-weight-500">{c.cardNumber}</div>
              {Array.from({ length: Math.ceil(getFields().length / 2) }).map(
                (r, i) => {
                  var fields = getFields();
                  var fieldId1 = fields[2 * i].id;
                  var fieldId2 = fields.length > 2 * i + 1 ? fields[2 * i + 1].id : null;
                  return (
                    <div key={`mobile-${c.cardNumber}-row-${i}`} className="row mt-2">
                      {getCell(c, fieldId1)}
                      {fields.length > 2 * i + 1 && getCell(c, fieldId2)}
                    </div>
                  );
                }
              )}
            </div>
            <div className="p-2 pointer" onClick={(e) => handleRowClick(e, c.cardNumber)}>
              <i className={`bx bx-chevron-right font-size-28 ${isRowSelected ? 'text-primary' : 'text-grey'}`}></i>
            </div>
          </div>
        )
      })}
    </div>
  );
};

export default TableBodyMobile;
